import StsA360RegStep1AnswerModel from './sts-a360-reg-step1-answer.model';
import {StsRegistrationType} from './sts-registration-type.enum';
import { StsCaptcha } from './sts-captcha.model';


export default class StsA360RegStep1AnswersModel {
  answers: StsA360RegStep1AnswerModel[];
  mode: StsRegistrationType;
  captcha: StsCaptcha;
}
